var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "50px 16px", "background-color": "#2D2D2D" } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("img", {
          staticClass: "background-image",
          attrs: {
            loading: "lazy",
            src: require("../../assets/AgentLoginBackground.jpg")
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "backdrop" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("span", { staticClass: "sign-in-lbl" }, [
                    _vm._v("Reset Password")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { width: "100%", "margin-top": "16px" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "padding-bottom": "16px",
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          placeholder: "New Password",
                          type: _vm.viewNewPassword ? "text" : "password"
                        },
                        model: {
                          value: _vm.newPassword,
                          callback: function($$v) {
                            _vm.newPassword = $$v
                          },
                          expression: "newPassword"
                        }
                      },
                      [
                        _c("template", { slot: "prepend" }, [
                          _c("i", { staticClass: "el-icon-lock" })
                        ]),
                        _vm._v(" "),
                        !_vm.viewNewPassword
                          ? _c("template", { slot: "append" }, [
                              _c("i", {
                                staticClass: "el-icon-view",
                                on: {
                                  click: function($event) {
                                    _vm.viewNewPassword = !_vm.viewNewPassword
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.viewNewPassword
                          ? _c("template", { slot: "append" }, [
                              _c("i", [
                                _c("img", {
                                  staticClass: "icon-hide",
                                  attrs: {
                                    src: require("../../assets/el-icon-hide.svg")
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.viewNewPassword = !_vm.viewNewPassword
                                    }
                                  }
                                })
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "padding-bottom": "16px",
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          placeholder: "Confirm New Password",
                          type: _vm.viewConfirmPassword ? "text" : "password"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.saveNewPassword($event)
                          }
                        },
                        model: {
                          value: _vm.confirmPassword,
                          callback: function($$v) {
                            _vm.confirmPassword = $$v
                          },
                          expression: "confirmPassword"
                        }
                      },
                      [
                        _c("template", { slot: "prepend" }, [
                          _c("i", { staticClass: "el-icon-lock" })
                        ]),
                        _vm._v(" "),
                        !_vm.viewConfirmPassword
                          ? _c("template", { slot: "append" }, [
                              _c("i", {
                                staticClass: "el-icon-view",
                                on: {
                                  click: function($event) {
                                    _vm.viewConfirmPassword = !_vm.viewConfirmPassword
                                  }
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.viewConfirmPassword
                          ? _c("template", { slot: "append" }, [
                              _c("i", [
                                _c("img", {
                                  staticClass: "icon-hide",
                                  attrs: {
                                    src: require("../../assets/el-icon-hide.svg")
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.viewConfirmPassword = !_vm.viewConfirmPassword
                                    }
                                  }
                                })
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      "padding-bottom": "16px",
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        on: { click: _vm.saveNewPassword }
                      },
                      [_vm._v("Save")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c83afcb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c83afcb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reset/resetPasswordSection.vue
// module id = null
// module chunks = 